import wixData from 'wix-data';
import wixLocation from 'wix-location';

$w.onReady(function () {
	//TODO: write your page related code here...

});
//Validate Coupon code
export function validate_click(event) {
	wixData.query("coupons")
		.eq("code", $w('#input').value)
		.find()
		.then((results) => {
			if (results.items.length > 0) {
				//validate number of uses
				let coupons = results.items[0];
				let totalNumber = coupons.number;
				let totalUsed = coupons.used;
				let uses = totalNumber - totalUsed;
				if (uses > 0) {
					$w('#input').disable();
					$w('#validate').hide();
					$w("#dataset1").setFilter(wixData.filter()
						.eq("code", $w('#input').value)
					);
				let newCount = Number(coupons.used) + 1;
				coupons.used = newCount;
					 wixData.update("coupons", coupons);
					 console.log(newCount)
				} else {
					$w('#notAvilable').show();
				}

			} else {
				$w('#error').show();
			}
		})
		.catch((err) => {
			let errorMsg = err;
		});
}
//Hide code error
export function input_keyPress(event) {
	$w('#error').hide();
		$w('#notAvilable').hide();
}
//Go to payment
// export function pay_click(event) {
// 	wixData.query("coupons")
// 		.eq("code", $w('#input').value)
// 		.find()
// 		.then((results) => {
// 			if (results.items.length > 0) {
// 				let item = results.items[0];
// 				let newCount = Number(item.used) + 1;
// 				console.log(newCount)
// 				item.used = newCount;
// 				wixData.update('coupons', item)
// 					.then(() => {
// 						let url = item.url
// 						wixLocation.to(url)
// 					})
// 			} else {
// 				wixData.query("coupons")
// 					.eq("code", 'FULLPRICE')
// 					.find()
// 					.then((search) => {
// 						if (search.items.length > 0) {
// 							let item = search.items[0];
// 							let url = item.url
// 							wixLocation.to(url)
// 						}
// 					});
// 			}
// 		});
// }

